import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { Platform } from '@angular/cdk/platform';
import { has as hasLicenses } from '@onviobr/services/licenses';
import { getPreference, patchPreference, addPreference } from '@onviobr/services/preference';
import { DashboardPreference } from '@onviobr/blue-dashboard';

@Component({
	selector: 'app-firm-dashboard',
	templateUrl: './firm-dashboard.component.html',
	styleUrls: ['./firm-dashboard.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class FirmDashboardComponent implements OnInit {
	@Input() isLoading = true;
	@Input() background: string;

	public isLoadingDashboardLayout = true;
	public dashboardStyle = { opacity: 0, transition: '' };

	public licenseBilling = false;
	public licenseTimeAndExpense = false;

	public preferences: DashboardPreference;
	public preferenceId: string;

	public preference = {
		getPreference,
		patchPreference,
		addPreference
	};

	public licenses = hasLicenses;
	isEditable = false;

	constructor(platformService: Platform) {
		this.isEditable = !(platformService.TRIDENT || platformService.IOS);
	}

	async ngOnInit() {
		this.licenseBilling = await this.licenses('TimeAndBilling.Billing');
		this.licenseTimeAndExpense = await this.licenses('TimeAndBilling.TimeAndExpense');
		const preferences = await this.preference.getPreference('onvio', 'firmDashboard');
		if (preferences.length > 0) {
			this.preferenceId = preferences[0].id;
			this.preferences = preferences[0].value as DashboardPreference;
		}
		setTimeout(() => this._completeLoadingDashboard(), 2000);
	}

	// After the dashboard layout has loaded and should have manipulated the DOM, display it softly
	_completeLoadingDashboard(): void {
		this.isLoadingDashboardLayout = false;
		this.dashboardStyle = { opacity: 1, transition: 'opacity 2s' };
	}

	public async onSave(data: DashboardPreference) {
		try {
			if (this.preferenceId) {
				await this.preference.patchPreference(data, this.preferenceId);
			} else {
				await this.preference.addPreference({
					application: 'onvio',
					category: 'firmDashboard',
					value: data
				});
			}
		} catch (error) {
			console.error(error);
		}
	}
}
